import React from 'react';
import ReactDOM from 'react-dom/client';
import GlowFlowApp from './GlowFlowApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<GlowFlowApp />);
